<ng-container *ngIf="isLoads">
  <div class="load-messages">
    <div class="load-messages-wrap">
      <div class="dot-carousel d-flex justify-content-between"><i></i><i></i><i></i></div>
    </div>
  </div>
</ng-container>
<div class="position-relative">
  <div [class.modalMode]="modalMode" #scrollable class="scroll-sidebar">
    <div (click)="cd.detectChanges()" class="d-flex h-100 flex-column">
      <!-- Header -->
      <div class="border-bottom" [class.py-4.py-lg-6]="!modalMode">
        <div class="container-fluid">
          <ul class="nav justify-content-between align-content-end align-items-center">
            <!-- Close sidebar -->
            <li class="nav-item list-inline-item">
              <button *ngIf="!modalMode" (click)="onClose()" class="btn btn-sm nav-link px-0">
                <i-feather name="chevron-left" class="icon-md"></i-feather>
              </button>
            </li>
            <!-- Title(mobile) -->
            <li class="text-center d-block d-md-none"></li>
            <!-- Dropdown -->
            <!--<li class="nav-item list-inline-item">
                                  <div *ngIf="false" class="btn-group" dropdown placement="left">
                                    <button disabled dropdownToggle class="btn btn-sm nav-link px-0 btn-settings">
                                      <i-feather name="sliders" class="icon-md"></i-feather>
                                    </button>
                                    <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu"
                                        role="menu" aria-labelledby="button-animated">
                                      <li><a class="dropdown-item"><i-feather name="trash-2"></i-feather> Удалить</a></li>
                                    </ul>
                                  </div>
                                </li>-->
          </ul>
        </div>
      </div>
      <!-- Header -->
      <div *ngIf="!isLoaded && !initData" class="container-fluid">
        <div class="text-center my-8">
          <nz-space-item>
            <nz-skeleton-element
              class="rounded-circle overflow-hidden"
              nzType="image"
              [nzActive]="true"
            ></nz-skeleton-element>
          </nz-space-item>
        </div>
        <div class="row mb-8">
          <div class="col-6 mb-4">
            <nz-skeleton-element class="w-100" nzType="input" [nzActive]="true"
                                 [nzSize]="'large'"></nz-skeleton-element>
          </div>
          <div class="col-6 mb-4">
            <nz-skeleton-element class="w-100" nzType="input" [nzActive]="true"
                                 [nzSize]="'large'"></nz-skeleton-element>
          </div>
          <div class="col-6 mb-4">
            <nz-skeleton-element class="w-100" nzType="input" [nzActive]="true"
                                 [nzSize]="'large'"></nz-skeleton-element>
          </div>
          <div class="col-6 mb-4">
            <nz-skeleton-element class="w-100" nzType="input" [nzActive]="true"
                                 [nzSize]="'large'"></nz-skeleton-element>
          </div>
        </div>
        <nz-skeleton nzAvatar="true" class="mb-5" [nzActive]="true" [nzParagraph]="{ rows: 2 }"></nz-skeleton>
        <nz-skeleton nzAvatar="true" [nzActive]="true" [nzParagraph]="{ rows: 3 }"></nz-skeleton>
      </div>
      <!-- Body -->
      <div *ngIf="(isLoaded || initData)" class="flex-fill">
        <div #wrapFixedInfo>
          <div [class.sticky-top]="isSticky" class="border-bottom text-center py-4 px-10">
            <!-- Photo -->
            <app-avatar
              (click)="galleryService.openGallerySingle(arResult.chat?.avatar, arResult.chat?.avatar_orig)"
              [Service]="Service"
              [id]="arResult.chat?.id || ''"
              [class.avatar-online]="arResult?.chat?.online"
              [type]="arResult.chat?.type"
              [avatar]="arResult.chat?.avatar"
              [avatarFileId]="arResult.chat?.avatar_file_id"
              [avatarFileUniqueId]="arResult.chat?.avatar_file_unique_id"
              class="avatar pointer avatar-xl mx-5 mb-3"
            ></app-avatar>

            <div>
              <h5>
                <ng-template #load>
                  <span class="typing-dots"><span>.</span><span>.</span><span>.</span></span>
                </ng-template>
                <ng-template [ngIf]="arResult?.user?.name?.first || !isActual || !isLoaded" [ngIfElse]="elseUserName">
                  <div
                    *ngIf="arResult?.user?.name?.first; else load"
                    [innerHTML]="
                  arResult?.user?.name?.first + ' ' + arResult?.user?.name?.last | replaceEmojis: 'facebook':20:64
                "
                  ></div>
                </ng-template>
                <ng-template #elseUserName>
                  <div
                    [innerHTML]="interfaceService.getChatTitle(arResult?.chat,  arResult?.user)
                    | replaceEmojis: 'facebook':20:64
                "
                  ></div>
                </ng-template>
              </h5>
              <p
                *ngIf="arResult?.chat?.description"
                class="d-none-sticky text-muted mb-2"
                [innerHTML]="arResult.chat?.description | replaceEmojis: 'facebook':20:64"
              ></p>
              <div *ngIf="arResult?.user?.last_seen?.time" class="d-block-stycky">
                <app-text-user-online
                  [isActual]="isActual"
                  [last_seen]="arResult.user.last_seen"
                  [online]="arResult.user.online"
                ></app-text-user-online>
              </div>
            </div>
            <div [class.hidden]="isSticky" class="text-center mb-5">
              <div class="btn-group" role="group" aria-label="Calling">
                <ng-template [ngIf]="!interfaceService.isLeadsDomain">
                  <button (click)="callService.startCall(arResult.chat, Service, 'audio')" class="btn btn-secondary">
                    <i-feather [name]="'phone-call'"></i-feather>
                    <small class="d-block">Звонок</small>
                  </button>
                  <button (click)="callService.startCall(arResult.chat, Service, 'video')" class="btn btn-secondary">
                    <i-feather [name]="'video'"></i-feather>
                    <small class="d-block">Видео</small>
                  </button>
                  <button (click)="callService.startCall(arResult.chat, Service, 'share')"
                          *ngIf="webrtcService.isSupportShareScreen" class="btn btn-secondary">
                    <i-feather [name]="'monitor'"></i-feather>
                    <small class="d-block">Экран</small>
                  </button>
                </ng-template>
                <button (click)="openChat(id)" [class.hidden]="allMessengersService.Service._openChatId === id"
                         *ngIf="webrtcService.isSupportShareScreen" class="btn btn-secondary">
                  <i-feather [name]="'message-square'"></i-feather>
                  <small class="d-block">Написать</small>
                </button>
              </div>
            </div>
          </div>
        </div>

        <ul *ngIf="arResult.user" class="list-group list-group-flush">
          <li *ngIf="arResult?.user?.last_seen?.time" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Статус</p>
                <p>
                  <app-text-user-online
                    [isActual]="isActual"
                    [last_seen]="arResult.user.last_seen"
                    [online]="arResult.user.online"
                  ></app-text-user-online>
                </p>
              </div>
              <i-feather name="clock" class="text-muted"></i-feather>
            </div>
          </li>
          <li
            *ngIf="arResult.user?.phone_number && arResult.user.phone_number !== 'None'"
            class="list-group-item py-3"
          >
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Телефон</p>
                <p>
                  <a href="tel:{{ arResult.user.phone_number }}">{{ arResult.user.phone_number }}</a>
                </p>
              </div>
              <i-feather name="phone-call" class="text-muted"></i-feather>
            </div>
          </li>
          <li *ngIf="arResult.user.username && arResult.user.username !== 'None'" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Имя пользователя</p>
                <p><span *ngIf="showUserNamePrefix">@</span>{{ arResult.user.username }}</p>
              </div>
              <i-feather name="user" class="text-muted"></i-feather>
            </div>
          </li>

          <li *ngIf="arResult.user?.caltoutch_session_id" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Номер сессии Calltouch</p>
                <p>{{ arResult.user.caltoutch_session_id }}</p>
              </div>
              <i-feather name="phone-call" class="text-muted"></i-feather>
            </div>
          </li>
          <li *ngIf="arResult.user?.yandex_client_id" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">ID в Yandex Metrika</p>
                <p>{{ arResult.user.yandex_client_id }}</p>
              </div>
              <i-feather name="phone-call" class="text-muted"></i-feather>
            </div>
          </li>
          <li *ngIf="arResult.user.personal_url" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Личная ссылка</p>
                <p>
                  <a target="_blank" href="{{ arResult.user.personal_url }}">{{ arResult.user.personal_url }}</a>
                </p>
              </div>
              <i-feather name="external-link" class="text-muted"></i-feather>
            </div>
          </li>
          <li *ngIf="arResult.user.organization" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Организация</p>
                <p>
                  {{ arResult.user.organization }}
                </p>
                <p class="small text-muted mb-0">Организационная единица</p>
                <p>
                  {{ arResult.user.organization_unit }}
                </p>
              </div>
              <i-feather name="users" class="text-muted"></i-feather>
            </div>
          </li>
          <li *ngIf="arResult.user?.city?.title" class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="small text-muted mb-0">Местоположение</p>
                <p>
                  <ng-template [ngIf]="arResult.user?.country?.title">
                    {{ arResult.user.country?.title }},
                  </ng-template>
                  {{ arResult.user.city?.title }} {{arResult.user?.street}}
                </p>
              </div>
              <i-feather name="map-pin" class="text-muted"></i-feather>
            </div>
          </li>
        </ul>
        <ul *ngIf="arSettings" class="list-group list-group-flush">
          <li class="list-group-item py-3">
            <div class="media align-items-center">
              <div class="media-body">
                <div class="d-flex justify-content-between mb-2">
                  <!-- Title -->
                  <h6 class="mb-0">Уведолмения</h6>
                  <!-- Switch -->
                  <div class="custom-control custom-switch">
                    <input
                      [(ngModel)]="notify"
                      value="dark"
                      checked
                      type="checkbox"
                      class="custom-control-input"
                      id="custom-switch-notyfy"
                    />
                    <label class="custom-control-label" for="custom-switch-notyfy"></label>
                  </div>
                </div>
                <small class="text-muted">Уведомлять о новых сообщениях?</small>
              </div>
            </div>
          </li>
        </ul>
        <!--<ul *ngIf="false" class="list-group list-group-flush">
          <li class="list-group-item py-3">
            <a class="media text-muted">
              <div class="media-body align-self-center">Twitter</div>
              <i class="icon-sm fe-twitter"></i>
            </a>
          </li>
          <li class="list-group-item py-3">
            <a class="media text-muted">
              <div class="media-body align-self-center">Facebook</div>
              <i class="icon-sm fe-facebook"></i>
            </a>
          </li>
          <li class="list-group-item py-3">
            <a class="media text-muted">
              <div class="media-body align-self-center">Github</div>
              <i class="icon-sm fe-github"></i>
            </a>
          </li>
        </ul>-->

        <tabset
          class="d-block tab-grid"
          *ngIf="
          arResult.chat?.members?.length > 0 ||
          arResult.document?.length > 0 ||
          arResult.photo?.length > 0 ||
          arResult.url?.length > 0 ||
          (arResult.video?.length > 0 && arResult.voice_note?.length > 0 && arResult.audio?.length > 0)
        "
          type="pills"
        >
          <tab *ngIf="arResult.chat?.members?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="users"></i-feather>
              Участники
            </ng-template>
            <div class="p-5 nav-tabs bg-secondary">
              <div
                class="chat-group mb-6 nav-link p-0 text-reset"
                *ngFor="let member of arResult.chat?.members; let i = index"
              >
                <div class="card card-active-listener">
                  <div class="card-body">
                    <div class="media">
                      <app-avatar
                        [Service]="Service"
                        [id]="member.id"
                        [class.avatar-online]="member?.online"
                        [type]="'private'"
                        [avatar]="member.avatar"
                        [avatarFileId]="member.avatar_file_id"
                        [avatarFileUniqueId]="member?.avatar_file_unique_id"
                        class="avatar mr-5"
                      ></app-avatar>
                      <div class="media-body overflow-hidden">
                        <h6 class="text-truncate mr-auto mb-1">
                        <span
                          *ngIf="member?.name?.first"
                          [innerHTML]="member?.name?.first + ' ' + member?.name?.last | replaceEmojis: 'facebook':20:64"
                        ></span>
                          <span *ngIf="!member?.name?.first">{{ member.username }}</span>
                        </h6>
                        <p class="small text-muted text-nowrap">
                          <span *ngIf="member.online" class="text-muted">Онлайн</span>
                          <span *ngIf="!member.online && member.last_seen.time" class="text-muted"
                          >Заходил(a)
                          <span *ngIf="isActual">{{ member.last_seen.time * 1000 | timeago }}</span>
                            {{ member.last_seen.platform }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab>
          <tab *ngIf="arResult.document?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="file"></i-feather>
              Файлы
            </ng-template>
            <div
              *ngFor="let message of arResult.document; let i = index"
              class="d-block list-group list-group-flush list-group-no-border-first"
            >
              <h4 class="py-4 text-center" *ngIf="message.show_title">
                <i-feather name="Calendar"></i-feather>
                {{ message.date_format }}
              </h4>
              <!-- File -->
              <div (deferLoad)="getFileSrc(message.attachment)" class="list-group-item py-4">
                <div class="media">
                  <a rel="noopener" target="_blank" [href]="message.attachment?.file_uri">
                    <div class="icon-shape bg-primary text-white mr-5">
                      <i-feather name="file"></i-feather>
                    </div>
                  </a>
                  <div class="media-body align-self-center overflow-hidden">
                    <h6 class="mb-0">
                      <a
                        [href]="message.attachment?.file_uri"
                        rel="noopener"
                        target="_blank"
                        class="text-reset text-truncate d-block"
                        title="{{ message.attachment?.file_name }}"
                      >
                        {{ message.attachment?.file_name }}
                      </a>
                    </h6>
                    <a [href]="message?.attachment?.file_uri" rel="noopener" target="_blank">
                      <div class="message-bottom mt-1 d-flex justify-content-between small">
                        <div>
                          <i-feather name="clock" class="mr-2 text-muted"></i-feather
                          >
                          <small class="text-muted">{{ message.date * 1000 | date: 'd hh:mm' }}</small>
                        </div>
                        <span class="text-muted mx-2 text-truncate d-block">{{ message.attachment?.mime_type }}</span>
                        <span class="text-muted">{{ appService.bytesToSize(message.attachment?.file_size) }}</span>
                      </div>
                    </a>
                  </div>

                  <div class="align-self-center ml-5">
                    <div class="btn-group" dropdown placement="left">
                      <button dropdownToggle class="btn btn-sm btn-ico btn-link text-muted w-auto">
                        <i-feather name="more-vertical" class="icon-md"></i-feather>
                      </button>
                      <ul *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-animated">
                        <li class="pointer" (click)="modalService.openModal('ModalForwardMessageComponent', {
                            Service: Service,
                            messages: [message],
                            chatId: this.id
                          })">
                          <a class="dropdown-item">
                            <i-feather name="share"></i-feather>
                            Переслать</a>
                        </li>
                        <li>
                          <a [href]="message.attachment.file_uri" rel="noopener" target="_blank" class="dropdown-item"
                          >
                            <i-feather name="volume-x"></i-feather>
                            Скачать</a
                          >
                        </li>
                        <!--<li>
                                                  <a class="dropdown-item"
                                                  ><i-feather name="trash-2"></i-feather> Удалить</a
                                                  >
                                              </li>-->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- File -->
            </div>
          </tab>
          <tab *ngIf="arResult.photo?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="image"></i-feather>
              Фото
            </ng-template>
            <div class="container-fluid px-4 lightGallery">
              <div class="py-4 row mx-0">
                <ng-container *ngFor="let message of arResult.photo; let i = index">
                  <div *ngIf="message.show_title" class="col-12">
                    <h4 class="py-4 text-center">
                      <i-feather name="Calendar"></i-feather>
                      {{ message.date_format }}</h4>
                  </div>
                  <div class="col-4 mb-4 px-2" (deferLoad)="getAllSrc(message.attachment)">
                    <div *ngIf="message?.attachment?.thumb" [ngStyle]="{ height: '120px' }">
                      <a
                        [attr.data-caption]="message.text"
                        data-fancybox="gallery"
                        (click)="galleryService.openGallery($event, message.attachment.file_uri)"
                        [href]="message.attachment.file_uri"
                      >
                        <div
                          *ngIf="!message.attachment.thumb.file_uri"
                          class="d-flex h-100 flex-column justify-content-center align-items-center"
                        >
                          <i-feather
                            *ngIf="!message.attachment.thumb?.file_uri_error; else errorImage"
                            class="icon-xxl"
                            name="image"
                          ></i-feather>
                        </div>
                        <img
                          loading="lazy"
                          (error)="loadImageAttachmentError($event, message.attachment)"
                          [ngStyle]="{ height: '120px' }"
                          *ngIf="message.attachment.thumb.file_uri"
                          class="rounded mb-4 pointer img-fluid w-100 cover"
                          [src]="message.attachment.thumb.file_uri"
                        />
                      </a>
                    </div>
                  </div>
                </ng-container>
                <div (deferVizible)="lazyLoad(true, 'photo')"></div>
              </div>
            </div>
          </tab>
          <tab *ngIf="arResult.url?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="link-2"></i-feather>
              Ссылки
            </ng-template>
            <div *ngFor="let message of arResult.url; let i = index">
              <h4 class="py-4 text-center" *ngIf="message.show_title">
                <i-feather name="Calendar"></i-feather>
                {{ message.date_format }}
              </h4>
              <div class="list-group-item py-4">
                <div *ngIf="message.attachment" class="media">
                  <div class="icon-shape bg-primary text-white mr-5">
                    <i-feather name="external-link"></i-feather>
                  </div>
                  <div class="media-body align-self-center overflow-hidden">
                    <h6 class="mb-0">
                      <a
                        rel="noopener"
                        target="_blank"
                        [href]="message.attachment.url"
                        class="text-reset text-truncate d-block"
                        title="{{ message.attachment.title }}"
                      >
                        {{ message.attachment.title }}
                      </a>
                    </h6>
                    <ul class="list-inline small mb-0">
                      <li class="list-inline-item">
                        <span class="">{{ message.attachment.description }}</span>
                      </li>
                      <li class="list-inline-item">
                        <a rel="noopener" target="_blank" [href]="message.attachment.url">{{
                          message.attachment.display_url
                          }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="!message.attachment" class="media">
                  <div class="icon-shape bg-primary text-white mr-5">
                    <i-feather name="external-link"></i-feather>
                  </div>
                  <div class="media-body align-self-center overflow-hidden">
                    <ul class="list-inline small mb-0">
                      <li class="list-inline-item">
                        <span [innerHTML]="message.text | href | replaceEmojis: 'facebook':24:64"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div (deferVizible)="lazyLoad(true, 'url')"></div>
          </tab>
          <tab *ngIf="arResult.video?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="video"></i-feather>
              Видео
            </ng-template>
            <div class="container-fluid px-4">
              <div class="py-4 row mx-0">
                <ng-container *ngFor="let message of arResult.video; let i = index">
                  <div *ngIf="message.show_title" class="col-12">
                    <h4 class="py-4 text-center">
                      <i-feather name="Calendar"></i-feather>
                      {{ message.date_format }}</h4>
                  </div>
                  <div *ngIf="message.attachment?.type === 'video_iframe'; else videoPlayer" class="col-12 mb-4 px-2">
                    <div [ngStyle]="{ width: '100%', height: '250px' }"
                         (deferLoad)="videoIframeInit(message.attachment)">
                      <iframe
                        *ngIf="message.attachment.player"
                        [ngStyle]="{ width: '100%', height: '250px' }"
                        [src]="message.attachment.player"
                        frameborder="0"
                      ></iframe>
                    </div>
                  </div>
                  <ng-template #videoPlayer>
                    <div class="col-4 mb-4 px-2">
                      <app-video-player
                        [play]="'hover'"
                        class="d-block overflow-hidden"
                        [styles]="{ width: '100%', height: '100px' }"
                        [caption]="message.text"
                        [vizible]="true"
                        [attachment]="message.attachment"
                        [Service]="Service"
                      ></app-video-player>
                    </div>
                  </ng-template>
                </ng-container>
                <div (deferVizible)="lazyLoad(true, 'video')"></div>
              </div>
            </div>
          </tab>
          <tab *ngIf="arResult.voice_note?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="voicemail"></i-feather>
              Голосовые
            </ng-template>
            <div *ngFor="let message of arResult.voice_note; let i = index" class="py-4 row justify-content-center">
              <div class="col-auto">
                <h4 class="py-4 text-center" *ngIf="message.show_title">
                  <i-feather name="Calendar"></i-feather>
                  {{ message.date_format }}
                </h4>
                <app-voice-player
                  *ngIf="message.voice && !message.hidden"
                  [voice]="message.voice"
                  [Service]="Service"
                ></app-voice-player>
              </div>
            </div>
          </tab>
          <tab *ngIf="arResult.audio?.length > 0">
            <ng-template tabHeading>
              <i-feather class="no-filter" name="music"></i-feather>
              Аудио
            </ng-template>
            <div *ngFor="let message of arResult.audio; let i = index" class="py-4 row mx-0 justify-content-center">
              <div class="col-auto">
                <h4 class="py-4 text-center" *ngIf="message.show_title">
                  <i-feather name="Calendar"></i-feather>
                  {{ message.date_format }}
                </h4>
                <app-message-player
                  [reverse]="!message.out"
                  [attachment]="message.attachment"
                  [Service]="Service"
                ></app-message-player>
              </div>
            </div>
            <div (deferVizible)="lazyLoad(true, 'audio')"></div>
          </tab>
        </tabset>
      </div>
      <!-- Body -->
    </div>
  </div>
</div>
<ng-template #errorImage>
  <div tooltip="Ошибка загрузки, нажмите, что бы повторить.">
    <i-feather class="icon-xxl" name="alert-octagon"></i-feather>
  </div>
</ng-template>
